
// load scss
import './Main.scss';

import '../JavaScript/index';
